module.exports = __webpack_public_path__ + "img/logo_interreg.38564649.png";